import App from "./App.svelte";

const app = new App({
	target: document.getElementById("cca"),
	props: {
		// location: false,
		location: true,
		// location: "texas",
	},
});

export default app;
